import React from 'react'
import { TextStyle } from 'react-native'
import { useHistory } from 'react-router'
import { color, Text } from '@trivie/ui-mobile'
import { Button } from '@mui/material'
import { Trans } from 'react-i18next'

import aha from './images/aha.png'

export const LoginScreen = () => {
  const history = useHistory()
  const goToMagicLink = () => history.push('/login/magic')
  const goToSignup = () => history.push('/signup')

  return (
    <div style={ROOT}>
      <div style={CONTENT}>
        <img style={AHA_LOGO} height={125.33} width={94} src={aha} alt="aha logo" />
        <Text style={AHA_HEADLINE} text="AHA KNOWLEDGE BOOSTER" variant="headline" />
        <Button
          role="link"
          aria-label="Sign up"
          type="button"
          style={{
            ...SUBMIT_BTN,
            marginBottom: 17,
          }}
          onClick={goToSignup}
        >
          <Text style={{ ...BTN_TXT, color: color.white }} tx="Onboarding.newSignup" />
        </Button>
        <Button
          role="link"
          aria-label="Go to magic link"
          type="button"
          style={{ ...SUBMIT_BTN, background: color.white }}
          onClick={goToMagicLink}
        >
          <Trans i18nKey="AHA.login" style={{ ...BTN_TXT }}>
            <Text style={{ ...BTN_TXT }} variant="headline" />
            <Text style={{ ...BTN_TXT, textDecorationLine: 'underline' }} variant="headline" />
          </Trans>
        </Button>
      </div>
    </div>
  )
}

const ROOT: React.CSSProperties = {
  flexDirection: 'row',
  flex: 1,
  display: 'flex',
  maxHeight: 576,
  justifyContent: 'center',
  width: '33%',
  minWidth: 375,
  alignSelf: 'center',
}
const AHA_HEADLINE: TextStyle = {
  marginBottom: 73,
  fontWeight: '600',
  fontSize: 32,
  lineHeight: 40.58,
  width: 370,
  textAlign: 'center',
}
const AHA_LOGO: React.CSSProperties = { marginBottom: 32, alignSelf: 'center' }
const CONTENT: React.CSSProperties = {
  height: '100%',
  flex: 1,
  backgroundColor: '#fff',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignSelf: 'center',
}
const SUBMIT_BTN: React.CSSProperties = {
  background: 'linear-gradient(180deg, #C10E21 0%, #990000 100%)',
  width: 335,
  alignSelf: 'center',
  borderRadius: 16,
  height: 52,
  border: 'none',
  cursor: 'pointer',
}
const BTN_TXT: TextStyle = {
  fontWeight: '500',
  fontSize: 17,
  lineHeight: 22,
  color: 'rgba(21, 30, 35, 1)',
}
